module.exports = __webpack_public_path__ + "static/media/sigma-small-blue.958a0f44.png";